module.exports = __webpack_public_path__ + "frontend/images/white/carousel/static/account.png?e19be1760013932733c3b46aa266d217";